export default __webpack_public_path__ + "static/media/skills-2.039cc044.png";